import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'WarningIcon',
  'warning',
  'M512 140.8c-169.662 0-307.2 137.539-307.2 307.2s137.538 307.2 307.2 307.2c169.661 0 307.2-137.538 307.2-307.2s-137.539-307.2-307.2-307.2zM512 38.4c226.217 0 409.6 183.383 409.6 409.6s-183.383 409.6-409.6 409.6c-226.216 0-409.6-183.384-409.6-409.6s183.384-409.6 409.6-409.6zM435.522 622.88l21.455-228.609c2.587-27.566 26.448-48.671 55.023-48.671s52.434 21.105 55.025 48.671l21.453 228.609c4.091 43.561-31.319 81.12-76.477 81.12-45.157 0-80.567-37.559-76.478-81.12zM512 192c-28.277 0-51.2 22.922-51.2 51.2s22.923 51.2 51.2 51.2c28.278 0 51.2-22.922 51.2-51.2s-22.922-51.2-51.2-51.2z',
)
